import { PRODUCT_META, ProductCode } from '@gb-ticket/shared-types';

/** Root path of the maintenance product in the Mitarbeiterportal. */
export const MAINTENANCE_ROOT = PRODUCT_META[ProductCode.MAINTENANCE].pathPrefix;

export const MAINTENANCE_CUSTOMERS_PATH = `${MAINTENANCE_ROOT}/kunden`;

export const MAINTENANCE_CUSTOMER_NEW_PATH = `${MAINTENANCE_CUSTOMERS_PATH}/neu`;

export function maintenanceCustomerPath(customerId: string): string {
  return `${MAINTENANCE_CUSTOMERS_PATH}/${customerId}`;
}

export function maintenanceCustomerNewPath(): string {
  return MAINTENANCE_CUSTOMER_NEW_PATH;
}

export function maintenanceCustomerEditPath(customerId: string): string {
  return `${maintenanceCustomerPath(customerId)}/bearbeiten`;
}

export function maintenanceCustomerProjectNewPath(customerId: string): string {
  return `${maintenanceCustomerPath(customerId)}/projekte/neu`;
}

export function maintenanceProjectPath(projectId: string): string {
  return `${MAINTENANCE_ROOT}/projekte/${projectId}`;
}

export function maintenanceProjectEditPath(projectId: string): string {
  return `${maintenanceProjectPath(projectId)}/bearbeiten`;
}

export function maintenanceProjectInstallationNewPath(projectId: string): string {
  return `${maintenanceProjectPath(projectId)}/anlagen/neu`;
}

export function maintenanceInstallationPath(installationId: string): string {
  return `${MAINTENANCE_ROOT}/anlagen/${installationId}`;
}

export function maintenanceInstallationEditPath(installationId: string): string {
  return `${maintenanceInstallationPath(installationId)}/bearbeiten`;
}

export const MAINTENANCE_TEMPLATES_PATH = `${MAINTENANCE_ROOT}/vorlagen`;

export const MAINTENANCE_TEMPLATE_NEW_PATH = `${MAINTENANCE_TEMPLATES_PATH}/neu`;

export function maintenanceTemplateNewPath(): string {
  return MAINTENANCE_TEMPLATE_NEW_PATH;
}

export function maintenanceTemplatePath(templateId: string): string {
  return `${MAINTENANCE_TEMPLATES_PATH}/${templateId}`;
}

export function maintenanceTemplateVersionPath(templateId: string, versionId: string): string {
  return `${maintenanceTemplatePath(templateId)}/versionen/${versionId}`;
}

export const MAINTENANCE_PLANNING_PATH = `${MAINTENANCE_ROOT}/planung`;

export const MAINTENANCE_PLANNING_NEW_PATH = `${MAINTENANCE_PLANNING_PATH}/neu`;

export function maintenancePlanningNewPath(): string {
  return MAINTENANCE_PLANNING_NEW_PATH;
}
export const MAINTENANCE_ARCHIVE_PATH = `${MAINTENANCE_ROOT}/archiv`;

export const MAINTENANCE_TRASH_PATH = `${MAINTENANCE_ROOT}/papierkorb`;

export function maintenanceWorkOrderPath(workOrderId: string): string {
  return `${MAINTENANCE_ROOT}/auftraege/${workOrderId}`;
}

export function maintenanceWorkOrderEditPath(workOrderId: string): string {
  return `${MAINTENANCE_PLANNING_PATH}/${workOrderId}/bearbeiten`;
}

export function maintenanceProtocolPath(protocolId: string): string {
  return `${MAINTENANCE_ROOT}/protokolle/${protocolId}`;
}

export function maintenanceProtocolArchivePath(protocolId: string): string {
  return `${maintenanceProtocolPath(protocolId)}/archiv`;
}
